<div class="container">
    <div class="row margin-4">
        <div class="col-md-8 col-12">
            <div id="myCarousel" class="carousel slide border" data-ride="carousel">

                <!-- end indicators -->
                <div class="carousel-inner">
                    <div *ngFor="let banner of banners" class="{{banner?.style}}">
                        <!--Caption here -->
                        <div class="carousel-caption">
                            <p>
                                <a style="cursor: pointer;">{{banner.titleshortevent}}</a>
                            </p>
                        </div>
                        <!-- end caption -->
                        <img (click)="onNewsClick(banner)" class="d-block w-100 img-slide" src="{{banner?.pathimage}}"
                            alt="Black Cat" />
                    </div>

                    <!-- Controls -->
                    <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-12">
            <div class="card card-notification">
                <div class="card-body">
                    <div class="title-cate">
                        <a>Thông báo</a>
                        <p class="line"></p>
                    </div>
                    <div *ngIf="notifications" class="list-notice">
                        <div *ngFor="let notification of notifications" class="item">
                            <img *ngIf="notification?.isNew" src="assets/img/newicon_vi.gif"
                                alt="{{notification?.title}}" />
                            <a class="custom-hover" title="{{notification.title}}"
                                (click)="onTitleClick1(notification)">{{notification.titleshort }}
                            </a>
                            <span> <i class="fa fa-clock-o mr-2"
                                    aria-hidden="true"></i>{{notification.postdate | date:'dd/MM/yyyy'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>
<div class="container">
    <!----------------------------------- Tuyển sinh - Đào Tạo  -------------------------->

    <div class="row margin-4">
        <div class="col-md-8 col-12 tab-news">
            <ul class="nav nav-pills nav-department" id="pills-tab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="tab-1" data-toggle="pill" href="#tuyen-sinh" role="tab"
                        aria-controls="pills-home" aria-selected="true">Bảo Đảm Chất Lượng</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" id="tab-2" data-toggle="pill" href="#event" role="tab"
                        aria-controls="pills-profile" aria-selected="false">Quy Chế-Quy Định</a>
                </li> -->
                <!-- <li class="nav-item">
                    <a class="nav-link" id="tab-3" data-toggle="pill" href="#doan" role="tab"
                        aria-controls="pills-contact" aria-selected="false">Biểu Mẫu-Tài Liệu</a>
                </li> -->
            </ul>
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="tuyen-sinh" role="tabpanel" aria-labelledby="tab-1">
                    <div class="articles row">
                        <article class="col-md-6 mt-2 mb-2 col-tabs-news" *ngFor="let admission of admissions">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="post-img">
                                        <img *ngIf="admission?.pathimage!=''" src="{{admission.pathimage}}"
                                            alt="{{admission?.title}}" (click)="onTitleClick(admission)">
                                        <img *ngIf="admission?.pathimage==''" src="/assets/img/noimage-1.png"
                                            alt="{{admission?.title}}" (click)="onTitleClick(admission)">
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <div class="post-slide">

                                        <p class="post-title"><a (click)="onTitleClick(admission)"
                                                title="{{admission.title}}">
                                                {{admission.titleshortadmissions}}</a>

                                        </p>
                                        <div class="date">
                                            <i class="fa fa-clock-o mr-2" aria-hidden="true"></i>

                                            <span class="date-detail"> {{admission.postdate | date:'dd/MM/yyyy'}}</span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>

                <div class="tab-pane fade" id="event" role="tabpanel" aria-labelledby="tab-2">
                    <div class="articles row" *ngIf="tab2">
                        <article class="col-md-6 mt-2 mb-2 col-tabs-news" *ngFor="let event of tab2">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="post-img">
                                        <img *ngIf="event.pathimage!=''" class="custom-hover"
                                            (click)="onTitleClick(event)" src="{{event.pathimage}}" />
                                        <img *ngIf="event?.pathimage==''" class="custom-hover"
                                            (click)="onTitleClick(event)" src="/assets/img/noimage-1.png" />
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <div class="post-slide">

                                        <p class="post-title"><a (click)="onTitleClick(event)" title="{{event.title}}">
                                                {{event.titleshorttab2}}</a>

                                        </p>
                                        <div class="date">
                                            <i class="fa fa-clock-o mr-2" aria-hidden="true"></i>

                                            <span class="date-detail"> {{event.postdate | date:'dd/MM/yyyy'}}</span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
                <div class="tab-pane fade" id="doan" role="tabpanel" aria-labelledby="tab-3">
                    <div class="articles row" *ngIf="associations">
                        <article class="col-md-6 mt-2 mb-2 col-tabs-news" *ngFor="let association of associations">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="post-img">
                                        <img *ngIf="association.pathimage!=''" class="custom-hover"
                                            (click)="onTitleClick(association)" src="{{association.pathimage}}" />
                                        <img *ngIf="association.pathimage==''" class="custom-hover"
                                            (click)="onTitleClick(association)" src="/assets/img/noimage-1.png" />
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <div class="post-slide">

                                        <p class="post-title"><a (click)="onTitleClick(association)"
                                                title="{{association.title}}">
                                                {{association.titleshortassociation}}</a>

                                        </p>
                                        <div class="date">
                                            <i class="fa fa-clock-o mr-2" aria-hidden="true"></i>

                                            <span class="date-detail"> {{association.postdate | date:'dd/MM/yyyy'}}</span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-12">
            <div class="card card-news">
                <div class="card-body">
                    <div class="title-cate">
                        <a>Tin tức</a>
                        <p class="line"></p>
                    </div>
                    <div *ngIf="focusNews" class="list-notice">
                        <div *ngFor="let focusNew of focusNews" class="item">
                            <img *ngIf="focusNew.isNew" src="assets/img/newicon_vi.gif" alt="{{focusNew?.title}}" />
                            <a class="custom-hover" title="{{focusNew.title}}"
                                (click)="onTitleClick1(focusNew)">{{focusNew.titleshortnews }}
                            </a>
                            <span> <i class="fa fa-clock-o mr-2"
                                    aria-hidden="true"></i>{{focusNew.postdate | date:'dd/MM/yyyy'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!----------------------------------- End Tuyển sinh - Đào Tạo   -------------------------->

    <!----------------------------------- Sự kiện  -------------------------->
    <div class="row margin-4">
        <div class="col-md-8 col-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="title-cate">
                        <a>Khảo Thí</a>
                        <p class="line"></p>
                    </div>
                </div>
                <div class="col-md-6 col-event" *ngFor="let event of events">
                    <div class="card border-0 shadow card-event" (click)="onTitleClick(event)">
                        <img *ngIf="event.pathimage!=''" src="{{event.pathimage}}" class="card-img-top">
                        <img *ngIf="event?.pathimage==''" src="/assets/img/noimage-1.png" class="card-img-top">
                        <div class="card-body text-left card-event-text">
                            <h5 class="card-title mb-0 h5-event" title="event.title">{{event.titleshortevent }}</h5>
                            <div class="card-text text-black-50">
                                <div class="date">
                                    <i class="fa fa-clock-o mr-2" aria-hidden="true"></i>

                                    <span class="date-detail"> {{event.postdate | date:'dd/MM/yyyy'}}</span>
                                    <i class="fa fa-eye mr-2" aria-hidden="true"></i>
                                    <span>{{event.view}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-md-4 col-12">

            <!-- Hệ thống hỗ trợ -->
            <div class="card">
                <div class="card-body">
                    <div class="title-cate">
                        <a>Hệ thống hỗ trợ </a>
                        <p class="line"></p>
                    </div>
                    <div class="sys-help">
                        <div class="col-content">
                            <a target="_blank" href="http://tinchi.hce.edu.vn/"><img
                                    src="assets/img/st_20131009135222.png" alt="Trang Sinh Viên">
                                <p>Trang Sinh Viên</p>
                            </a>
                        </div>
                        <div class="col-content">
                            <a target="_blank" href="http://tacnghiep.hce.edu.vn/"><img
                                    src="assets/img/global_telecom.png" alt="Trang tác nghiệp">
                                <p>Trang tác nghiệp</p>
                            </a>
                        </div>
                        <div class="col-content">
                            <a target="_blank" href="http://thuvienso.hce.edu.vn/"><img
                                    src="assets/img/dtkh_20140221112626.jpg" alt="Thư Viện Điện Tử">
                                <p>Thư Viện Điện Tử</p>
                            </a>
                        </div>
                        <div class="col-content">
                            <a target="_blank" href="http://lib.hce.edu.vn/?cat_id=105&amp;tid=1"><img
                                    src="assets/img/contact_email.png" alt="Giáo Trình Điện Tử">
                                <p>Giáo Trình Điện Tử</p>
                            </a>
                        </div>
                        <div class="col-content">
                            <a target="_blank" href="http://thuvienso.hce.edu.vn/"><img src="assets/img/globe_model.png"
                                    alt="Thư Viện Số">
                                <p>Thư Viện Số</p>
                            </a>
                        </div>
                        <div class="col-content">
                            <a target="_blank" href="https://khaosat.hce.edu.vn/#/"><img
                                    src="assets/img/chart_pie_edit (1).png" alt="Khảo Sát Trực Tuyến">
                                <p>Khảo Sát Trực Tuyến</p>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
            <!-- END Hệ thống hỗ trợ  -->

            <!-- Hình ảnh hoạt động -->
            <div class="card margin-4">
                <div class="card-body">

                    <div class="img-activity">
                        <div class="title-cate">
                            <a>Hình ảnh hoạt động </a>
                            <p class="line"></p>
                        </div>
                        <div id="img-activity" class="carousel slide border" data-ride="carousel">
                            <div *ngIf="albums" class="carousel-inner">
                                <div *ngFor="let album of albums" class="{{album?.style}}">
                                    <img (click)="onImageClick(album)" class="d-block w-100 img-carousel"
                                        src="{{album?.pathimage}}" alt="{{album?.title}}" />
                                    <div class="carousel-caption">
                                        <p>{{album?.title | slice:0:30}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#img-activity" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#img-activity" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
            </div>
            <!-- END Hình ảnh hoạt động  -->

            <!--liên kết website -->
            <div class="link-web">
                <div class="title">
                    <div class="icon-title">
                        <img class="img-responsive" alt="Liên kết Website" class="img-responsive"
                            src="assets/img/world.png" />
                        <span class="table-cell">Liên kết Website</span>
                    </div>
                </div>
                <div class="select-link">
                    <div class="form-group">
                        <select (change)="onLinkChange($event)" class="form-control" style="width:99%;"
                            id="link-website">
                            <option value="">-- Chọn liên kết website --</option>
                            <option *ngFor="let item of listConnectiveWebsite" [value]="item?.link">{{item?.title}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>



        </div>
        <!-- Liên kêt -->
        <div *ngIf="bannersLink?.length>0 || bannersMobile?.length>0" class="col-lg-12 col-md-12 col-sm-12 p-0 mt-0">
            <h4 class="h4-link">{{text_link}}</h4>
            <div *ngIf="!isMobile" id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item " [ngClass]="{'active': slideItem?.active}"
                        *ngFor="let slideItem of bannersLink">
                        <div class="row" *ngFor="let rowSlide of slideItem?.rowSlide">
                            <div class="col-md-3 col-xs-3 col-6" *ngFor="let colSlide of rowSlide">
                                <a [title]="colSlide?.title" [href]="colSlide?.link" target="_blank"
                                    class="thumbnail"><img src="{{colSlide?.pathimage}}" alt="{{colSlide?.title}}"
                                        class="img-slider"></a>
                            </div>

                        </div>

                    </div>
                    <!-- Controls -->
                    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>
            <div *ngIf="isMobile" id="carouselExampleIndicatorsMobile" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                    <div class="{{bannerMobile?.style}}" *ngFor="let bannerMobile of bannersMobile">
                        <div class="row">
                            <div class="col-12">
                                <a [title]="bannerMobile?.title" [href]="bannerMobile?.link" target="_blank"
                                    class="thumbnail"><img src="{{bannerMobile?.pathimage}}"
                                        alt="{{bannerMobile?.title}}" class="img-slider"></a>
                            </div>

                        </div>

                    </div>
                    <!-- Controls -->
                    <a class="carousel-control-prev" href="#carouselExampleIndicatorsMobile" role="button"
                        data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleIndicatorsMobile" role="button"
                        data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>
        </div>


    </div>
    <!----------------------------------- End Sự kiện  -------------------------->


</div>